import React from 'react';

export default (NotificationTemplate, DefaultButton) => {
	return function levelUpNotification(props) {
		return <NotificationTemplate {...props} button={DefaultButton} />;
	};
};
